module.exports = __webpack_public_path__ + "img/13.2009d158.png";